export const TOUR_ADMIN_BOOKING_DETAILS_START = 'TOUR_ADMIN_BOOKING_DETAILS_START';
export const TOUR_ADMIN_BOOKING_DETAILS_SUCCESS = 'TOUR_ADMIN_BOOKING_DETAILS_SUCCESS';
export const TOUR_ADMIN_BOOKING_DETAILS_ERROR = 'TOUR_ADMIN_BOOKING_DETAILS_ERROR'